'use client';

import { ChevronLeft } from '@drift-labs/icons';
import { UiVaultConfig } from 'src/@types/vaults';
import { PageRoute } from 'src/constants/constants';
import useIsMobileScreenSize from 'src/hooks/useIsMobileScreenSize';
import { useVaultStats } from 'src/hooks/query/vaults/derived/useVaultStats';
import { FeeChangeMessageContent } from '../FeeChanges';
import { VaultManagerIcon } from '../VaultManagerIcon';
import InlineAlert from 'src/components/primitives/InlineAlert/InlineAlert';
import { VaultTags } from '../VaultTags';
import Link from 'src/components/primitives/Link/Link';

const FeeChangeWarningMessage = (props: { vaultConfig: UiVaultConfig }) => {
	const relevantFeeChanges = props.vaultConfig.feeChangesToAlert;

	if (relevantFeeChanges.length === 0) {
		return null;
	}

	return (
		<InlineAlert variant="warning" title="Fee Changes">
			<FeeChangeMessageContent vaultConfig={props.vaultConfig} />
		</InlineAlert>
	);
};

export const VaultInfoHeader = (props: { uiVaultConfig: UiVaultConfig }) => {
	const isMobile = useIsMobileScreenSize();
	const { data: vaultStats } = useVaultStats(
		props.uiVaultConfig.vaultPubkeyString
	);
	const numOfVaultSnapshots = vaultStats?.numOfVaultSnapshots ?? 0;

	const hasFeeChangesToWarnAbout =
		props.uiVaultConfig.feeChangesToAlert?.length > 0;

	return (
		<div className="flex flex-col">
			<Link
				variant="secondary"
				className="mb-6 typo-t2"
				href={`/${PageRoute.vaults}/strategy-vaults`}
				leftIcon={ChevronLeft}
				rightIcon="none"
			>
				Back
			</Link>
			<div className="flex flex-wrap items-end justify-between gap-x-4 gap-y-2">
				<div className="flex flex-wrap items-center gap-x-1 md:gap-x-4">
					<VaultManagerIcon
						uiVaultConfig={props.uiVaultConfig}
						size={isMobile ? 24 : 48}
						assetSize={isMobile ? 12 : 20}
					/>
					<span className="typo-h4">{props.uiVaultConfig.name}</span>
					<VaultTags
						excludeName
						uiVaultConfig={props.uiVaultConfig}
						numOfVaultSnapshots={numOfVaultSnapshots}
					/>
				</div>
			</div>
			{hasFeeChangesToWarnAbout && (
				<div className="mt-8 flex items-center">
					<FeeChangeWarningMessage vaultConfig={props.uiVaultConfig} />
				</div>
			)}
		</div>
	);
};
